import React, { useContext, useState, useEffect } from 'react';
import { useImmerReducer } from 'use-immer';
import { Link as RouterLink } from 'react-router-dom';
import axiosConfig from '../../../utils/axiosConfig';
import axios from 'axios';
import Cookies from 'js-cookie';
import './Login.css';
import useStyles from './LoginStyles';

import Alert from '@material-ui/lab/Alert';
import Image from 'material-ui-image';

import {
    Box,
    Button,
    Checkbox,
    CssBaseline,
    CircularProgress,
    FormControlLabel,
    Grid,
    Link,
    Paper,
    TextField,
    Typography
} from '@material-ui/core';

/* Context */
import { GlobalProvider, StateContext, DispatchContext } from '../../../context/Provider';

const Login = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState } = appState;
    const { authDispatch, globalDispatch } = appDispatch;

    const originalState = {
        isLoading: false,
        loginErrorMessage: "",
        email: {
            value: "",
            hasErrors: false,
            message: ""
        },
        password: {
            value: "",
            hasErrors: false,
            message: ""
        }
    }

    const ourReducer = (draft, action) => {
        switch (action.type) {
            case "emailChange":
                draft.email.hasErrors = false;
                draft.email.message = null;
                draft.email.value = action.value;
                return
            case "passwordChange":
                draft.password.hasErrors = false;
                draft.password.message = null;
                draft.password.value = action.value;
                return
            case "validateEmail":
                if (!action.value.trim()) {
                    draft.email.hasErrors = true;
                    draft.email.message = "The Email field is required.";
                }
                return
            case "validatePassword":
                if (!action.value.trim()) {
                    draft.password.hasErrors = true;
                    draft.password.message = "The password field is required.";
                }
                return
            case "setLoadingStatus":
                draft.isLoading = action.value;
                return
            case "loginError":
                draft.loginErrorMessage = action.value;
                return
            default:
                return
        }
    }

    const [state, dispatch] = useImmerReducer(ourReducer, originalState);

    const handleSubmit = (e) => {

        e.preventDefault();
        dispatch({ type: "validateEmail", value: state.email.value });
        dispatch({ type: "validatePassword", value: state.password.value });
        dispatch({ type: "loginError", value: ""});
        dispatch({ type: "setLoadingStatus", value: true});

        axiosConfig.post(`/auth/login`, {
            email: state.email.value,
            password: state.password.value
        }).then(response => {

            if (response.data) {
                const { access_token, expires_in, auth_user } = response.data;

                localStorage.setItem('accessToken', access_token);

                Cookies.set('accessToken', access_token, { sameSite: 'lax', expires: 1 }); // days
                Cookies.set('authUser', auth_user, { sameSite: 'lax', expires: 1 });
                authDispatch({ type: "login", data: auth_user});

                if (auth_user.is_new === 1) {
                    props.history.push(`/reset-password/${auth_user.resetToken}`);
                } else {
                    props.history.push('/announcements');
                }
            }

        }).catch(err => {
            if (err.response) {
                const { error } = err.response.data;
                dispatch({ type: "loginError", value: error});
            } else {
                dispatch({ type: "loginError", value: 'Network error. Please try again later.'});
            }
        }).finally(res => {
            dispatch({ type: "setLoadingStatus", value: false});
        });
    }

    const classes = useStyles();
    const [loginLogo, setLoginLogo] = useState('');

    async function getSchoolInformation() {

        try {

            let host = window.location.host;
            let protocol = window.location.protocol;
            let parts = host.split(".");
            let subdomain = parts[0];

            const response = await axiosConfig.get(`/getSchoolInformation?subdomain=${subdomain}`);
            const { school } = response.data.data;

            if (school) {
                setLoginLogo(school.logo);
            } else {
                setLoginLogo('/images/ap_epi_logo-resized.png');
            }

            console.log(loginLogo);

        } catch(e) {
            console.log(e);
        }
    }

    useEffect(() => {
        console.log('login page');
        globalDispatch({type: 'setShowTabs', value: false});
        getSchoolInformation();
    }, []);

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>

                    <Box mb={2}>
                        <Image
                            src={loginLogo}
                            imageStyle={{
                                width: '',
                                height: '120px',
                                position: 'relative'
                            }}
                            style={{paddingTop: '0'}}
                        />
                    </Box>

                    { state.loginErrorMessage != '' ?
                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                            { state.loginErrorMessage }
                        </Alert>
                        : ''
                    }

                    <form className={classes.form} onSubmit={handleSubmit} noValidate>
                        <TextField
                            onChange={(e) => dispatch({ type: "emailChange", value: e.target.value })}
                            value={state.email.value}
                            error={state.email.hasErrors}
                            helperText={state.email.message}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Email Address"
                            name="email"
                            type="email"
                            autoComplete="off"
                            autoFocus
                        />
                        <TextField
                            onChange={(e) => dispatch({ type: "passwordChange", value: e.target.value })}
                            value={state.password.value}
                            error={state.password.hasErrors}
                            helperText={state.password.message}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            autoComplete="off"
                        />

                        <Link
                            component={RouterLink}
                            variant="body2"
                            underline="always"
                            to="/forgot-password"
                        >
                            Forgot Password?
                        </Link>

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disabled={state.isLoading}
                            disableElevation
                        >
                            { state.isLoading
                                ? (<CircularProgress size={24} className={classes.buttonProgress} />)
                                : 'LOGIN'
                            }
                        </Button>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
}

export default Login;